import  FetchData, { } from '../../client';
import {getBranchId, getHospitalId, getLoginID}  from '../../../auth';
import formAPIModelDoctorFavVaccine from '../../domains/doctorfavourite/vaccine/vaccines';

//reac the file

  const GetDoctorFavVaccine = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_getdoctorfavvaccine", inputData);
      // console.log(result, " DB result of get Fav Labs")
      if(result.output.message){
        return result
      }else if(result.output.data) {
      var data = formAPIModelDoctorFavVaccine(result.output.data)
      let count = result?.output?.count;
      let pageno  = result?.output?.pageno;
      let pagesize =  result?.output?.pagesize;
    var finalOutput = {
        data,
        count,
        pageno,
        pagesize
    }
      return finalOutput;
      }
      
    } catch (error) {
      console.error("Error fetching data in getdoctorfavvaccine :", error);
      throw error;
    }
  };
  const AddDoctorFavVaccine = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_adddoctorfavvaccine", inputData);
     
      return result;
    } catch (error) {
      console.error("Error fetching data in adddoctorfavvaccine :", error);
      throw error;
    }
  };
  const UpdateDoctorFavVaccine = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_updatedoctorfavvaccine", inputData);
     
      return result;
    } catch (error) {
      console.error("Error fetching data in _updatedoctorfavvaccine :", error);
      throw error;
    }
  };
  const DeleteDoctorFavVaccine = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_deletedoctorfavvaccine", inputData);
     
      return result;
    } catch (error) {
      console.error("Error fetching data in deletedoctorfavvaccine :", error);
      throw error;
    }
  };
export {GetDoctorFavVaccine, AddDoctorFavVaccine,UpdateDoctorFavVaccine, DeleteDoctorFavVaccine};
